<app-page-breadcrumb [pageInfo]="pageInfo" [isModal]="isModal" style="margin-right: 10px;"></app-page-breadcrumb>
<div class="body" [hidden]="loadingData">
  <div class="tab-content card pt-2 pl-4 pr-3 main_page">
    @if(!invoiceId && !isModal){
    <app-form-generator (onChangeEvent)="onChange($event)" [formData]="basicFormData1" class="mt-0">
    </app-form-generator>
    }
    <div class="d-flex justify-content-between">
      <h6 class="mt-2 patient_heading " [ngStyle]="{'color':theme_color}">Patient Details:</h6>
      <span class="align-self-center">
        <span class="mr-2"><button class="btn btn-primary" (click)="printInvoice(invoiceId)"><i
              class="las la-print"></i></button></span>
        @if(invoiceId && invoiceData?.status){
        <span
          class="h6 p-2 badge badge-{{invoiceData?.status ==1 ? 'success' :  invoiceData?.status ==2 ? 'warning' : 'primary'}}">
          {{invoiceData?.status ==1 ? 'Paid' : invoiceData?.status ==2 ? 'Pending' : 'Due'}}
        </span>
        }
      </span>
    </div>
    @if(invoiceData?.patient_id){
    <div class="d-flex row ml-1 p_details">
      <div class="d-flex flex-column col-lg-4 col-md-12">
        <p class="h6">
          <i class="las la-user"></i>
          <span class="text-muted">{{ invoiceData?.patientName }}</span>
        </p>
        <p class="h6">
          <i class="las la-hashtag"></i>
          <a href="javascript:void(0)">{{ invoiceData?.patient_id }}</a>
        </p>
      </div>
      <div class="d-flex flex-column col-lg-4 col-md-12">
        <p class="h6">
          <i class="las la-phone"></i>
          <span class="text-muted">{{ invoiceData?.mobile_no }}</span>
        </p>
        <p class="h6">
          <i class="las la-calendar-week"></i>
          <span class="text-muted">{{ invoiceData?.invoice_date | date:'dd-MM-yyyy' }}</span>
        </p>
      </div>
      <div class="d-flex flex-column col-lg-4 col-md-12">
        <p class="h6">
          <i class="lab la-slack-hash"></i>
          <a href="javascript:void(0)">{{ invoiceData?.invoice_id }}</a>
        </p>
      </div>
    </div>

    }
    @if(mode=='EDIT'&&invoiceData?.patient_id){
    <div class="row align-items-center" style="margin-right: 1px;">
      <div class="col-md-9 col-sm-12 col-lg-9">
        <app-form-generator #basicForm (onChangeEvent)="onChange($event)" [formData]="basicFormData" class="col-12 mt-0"
          (keyup)="onKey()"></app-form-generator>
      </div>
      <div class="col-sm-3 pt-md-3 col-md-3 col-lg-3 text-center">
        <button class="btn col-12 main-btn" [ngStyle]="{'background-color':theme_color}" (click)="addTreatment()"
          [disabled]="!subBtn">Add</button>
      </div>
    </div>
    }
    @if (invoiceData?.patient_id) {
    <app-table-list #tableData [tableConfig]="tableConfig" [parentGetList]="getTreatmentData"
      [parenttblAction]="tblAction"></app-table-list>
    }
    @if(treatmentList.length!=0){
    <div class="card p-5">
      <div class="form-group" [formGroup]="paymentForm">
        <div class="row d-flex">
          <div class="col-lg-8 col-md-12 col-sm-12">
            <table class="custom-table" style="width:80%;">
              <thead>
                <tr [ngStyle]="{'background-color':theme_color}">
                  <th>Payment Id</th>
                  <th>Date</th>
                  <th>Description</th>
                  <th>Amount</th>
                  <th>Created By</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of paymentData;">
                  <td>{{item.payments_id}}</td>
                  <td>{{item.created_at | date:'dd-MM-yyyy'}}</td>
                  <td>{{item.payments_des}}</td>
                  <td>{{item.amount}}</td>
                  <td>{{item.created_byName}}</td>
                </tr>
                <tr *ngIf="!paymentData || paymentData.length === 0">
                  <td colspan="4" class="text-center">No Invoice data Found</td>
                </tr>
              </tbody>
            </table>

          </div>
          <div class="col-lg-4 col-md-12 ms-auto" style="max-width: 250px;">
            <div class="row mb-2 align-items-center">
              <label class="col-6 col-form-label text-end fw-semibold text-nowrap">Net Amount :</label>
              <div class="col-6">
                <input type="text" class="form-control-plaintext text-end" [value]="overallAmount | number:'1.2-2'"
                  readonly>
              </div>
            </div>
            <div class="row mb-2">
              <label class="col-6 col-form-label text-end fw-semibold">Discount :</label>
              <div class="col-6 text-end">
                <ng-container *ngIf=" (mode === 'EDIT'); else readOnly">
                  <input type="text" class="form-control text-end" formControlName="discount" (keyup)="calTotal()">
                </ng-container>
                <ng-template #readOnly>
                  <span class="form-control-plaintext">{{ discountAmount | number:'1.2-2' }}</span>
                </ng-template>
              </div>
            </div>
            <div class="row mb-2">
              <label class="col-6 col-form-label text-end fw-semibold">Total :</label>
              <div class="col-6 text-end">
                <span class="form-control-plaintext">
                  {{
                  (mode === 'EDIT' || mode === 'VIEW') && invoiceId
                  ? (finalAmount |number:'1.2-2')
                  : finalAmount
                  | number:'1.2-2'
                  }}
                </span>
              </div>
            </div>

            <div class="row mb-2">
              <label class="col-6 col-form-label text-end fw-semibold">Total Paid :</label>
              <div class="col-6">
                <input type="text" class="form-control-plaintext text-end" [value]="invoiceData?.total_paid_amount || 0"
                  readonly>
              </div>
            </div>
            <div class="row mb-2">
              <label class="col-6 col-form-label text-end fw-semibold">Balance :</label>
              <div class="col-6 text-end">
                <span class="form-control-plaintext">
                  {{
                  (mode === 'VIEW')
                  ?( balanceAmt | number:'1.2-2')
                  :pendingAmount
                  | number:'1.2-2'
                  }}
                </span>
              </div>
            </div>
            <div class="row mb-2 align-items-center">
              <label class="col-5 col-form-label text-end fw-semibold text-nowrap">Payment Date :</label>
              <div class="col-7 text-end">
                @if(mode === 'EDIT'){
                <input type="date" class="form-control text-end payment-date-input" formControlName="payment_date">
                } @else {
                <span class="form-control-plaintext">
                  {{ paymentForm.value.payment_date ? (paymentForm.value.payment_date | date:'dd-MM-yyyy') : '-' }}
                </span>
                }
              </div>
            </div>
          </div>

        </div>
        @if(paidShowBtn){
        <div class="row  d-flex justify-content-end">
          <div class="col-2 ">
            <button [ngClass]="paidShowBtn=='Fully Paid'? 'success':'paid' " class="paid-show"
              disabled>{{paidShowBtn}}</button>
          </div>
        </div>
        }

        <div class="row mt-3">
          @if(mode=='EDIT' && invoiceData?.status != 1){
          <div class="col-lg-12 col-sm-12 col-md-12">
            <div class="input-group mb-3 payment-main">
              <span class="input-group-text payment-btn" [ngStyle]="{'background-color':theme_color}">₹</span>
              <input type="number" class="form-control" (keyup)="calTotalByMakePayment()" formControlName="payment"
                [defaultValue]="paymentShow" min="0">
              <button [disabled]="loading || loadingData" class="input-group-text payment-btn"
                [ngStyle]="{'background-color':theme_color}" noDoubleClick (click)="submit()">MakePayment</button>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
    }
  </div>
</div>
<app-page-loader [loading]="loadingData"></app-page-loader>